import { hasLocalFileContent } from "../utils/attachmentPreview";
import { useObjectUrl } from "./useObjectUrl";

/**
 * Blob URL when the user still has the original `File`, otherwise the remote
 * fallback (thumbnail in the strip, full S3 URL in the large preview).
 */
export function useFilePreviewUrl(
  file: File,
  remoteFallbackUrl: null | string,
): null | string {
  const objectUrl = useObjectUrl(hasLocalFileContent(file) ? file : null);

  return objectUrl ?? remoteFallbackUrl;
}
